import { Link, useNavigate } from "react-router";
import { signOut, useSession } from "../lib/auth.js";

export function MyPage() {
  const { data, isPending } = useSession();
  const navigate = useNavigate();

  return (
    <section>
      <h1>マイ</h1>
      {isPending ? (
        <p className="muted">読み込み中…</p>
      ) : data ? (
        <p className="row between">
          <span>{data.user.email}</span>
          <button
            className="btn"
            type="button"
            onClick={async () => {
              await signOut();
              navigate("/");
            }}
          >
            ログアウト
          </button>
        </p>
      ) : (
        <p>
          <Link className="btn primary" to="/login">
            ログイン / 新規登録
          </Link>
        </p>
      )}
      <ul className="list">
        <li>
          <Link to="/my/holdings">所持銘柄</Link>
        </li>
        <li>
          <Link to="/my/favorites">お気に入り</Link>
        </li>
        <li>
          <Link to="/my/long-term">長期保有</Link>
        </li>
        <li>
          <Link to="/my/summary">集計</Link>
        </li>
        <li>
          <Link to="/my/brokers">証券会社設定</Link>
        </li>
        <li>
          <Link to="/my/settings">設定</Link>
        </li>
        <li>
          <Link to="/admin">管理（管理者のみ）</Link>
        </li>
      </ul>
    </section>
  );
}
